type OptionShape = { readonly label: string };

/** Option labels are filled and differ from one another, whatever their case. */
function hasDistinctOptionLabels(value: readonly OptionShape[], _formData: unknown): boolean {
	const labels = value.map((option) => option.label.trim().toLowerCase());

	return labels.every((label) => label.length > 0) && new Set(labels).size === labels.length;
}

export default hasDistinctOptionLabels;
